module.exports = __webpack_public_path__ + "img/522.f953190a.png";